import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ModalService } from './modal.service';

@Component({
    selector: 'mlp-ng-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ModalSharedComponent {
    constructor(
        public modService: ModalService
    ) {}
}
